import { Button, Grid, Tooltip } from '@mui/material';
import { styled } from '@mui/material/styles';
import { Link, useNavigate } from 'react-router-dom';
import { useState, useEffect, Fragment, useContext } from 'react';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import { Trans, useTranslation } from 'react-i18next';
import { authService, userService } from 'src/services';
import { User } from 'src/models/user/user.model';
import SuspenseLoader from 'src/components/SuspenseLoader';
import {
  ACCOUNT_NUMBER, CURRENT_LANG, CURRENT_USER
} from 'src/constants';
import { authActions } from 'src/redux/actions';
import { useAppDispatch } from 'src/redux/hook';
import AzureAD, { AuthenticationState } from 'react-aad-msal';
import { authProvider } from 'src/services/auth.provider';
import { store } from 'src/redux/store';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { base64ToArrayBuffer } from 'src/utils/utils';
import { fileService } from 'src/services/file.service';
import DialogChoiceLangSf from 'src/components/Dialog/FicheDC/DialogChoiceLangSf';
import { ActionContext } from 'src/contexts/ActionContext';

const HeaderWrapper = styled(Grid)(
  ({ theme }) => `
    height: 60px;
    color: ${theme.header.textColor};
    padding: ${theme.spacing(0, 2)};
    right: 0;
    z-index: 6;
    background-color: ${theme.header.background};
    box-shadow: ${theme.header.boxShadow};
    position: fixed;
    justify-content: space-between;
    width: 100%;
`
);

const titleStyle = {
  color: '#2d2927',
  fontSize: '22px',
  marginTop: 2,
  fontFamily: 'inherit',
  fontWeight: 600,
  lineHeight: '1.5'
};

function Header(props) {
  const {
    REACT_APP_DEV_ONBOARDINGURL,
    REACT_APP_PP_ONBOARDINGURL,
    REACT_APP_PROD_ONBOARDINGURL,
    REACT_APP_NOTIFICATION_DURATION
  } = process.env;

  let navigate = useNavigate();
  const [headerData, setHeaderData] = useState({
    username: '',
    role: ''
  });
  const { t, i18n } = useTranslation();
  const titleData = props.headerAddon;
  const [userData, setUserData] = useState<User>(JSON.parse(localStorage.getItem(CURRENT_USER)));
  const [culture, isFrench] = useState(localStorage.getItem(CURRENT_LANG) === 'en' || false);
  const langTmp = localStorage.getItem(CURRENT_LANG);
  const username = headerData.username + " (" + t(headerData.role) + ")";
  const usernameTitle = userData?.firstName + " " + userData?.lastName + " (" + t(headerData.role) + ")";
  const [loading, setLoading] = useState(false);
  const dispatch = useAppDispatch();
  const [userAccount, setUserAccount] = useState<User[]>([]);
  const [displayAlertError, setDisplayAlertError] = useState<boolean>(true);
  const [userCurrrentRole, setUserCurrrentRole] = useState(0);
  const [openDialogChoiceLangSf, setOpenDialogChoiceLangSf] = useState<boolean>(false);

  const protocol = window.location.protocol;
  const domain = window.location.hostname;
  const port = window.location.port;

  const url = `${protocol}//${domain}${port ? ":" + port : ""}`;
  const isOnBoarding = (url === REACT_APP_DEV_ONBOARDINGURL) || (url === REACT_APP_PP_ONBOARDINGURL) || (url === REACT_APP_PROD_ONBOARDINGURL);
  const {
    currentIdLangUserDc
  } = useContext(ActionContext);
  useEffect(() => {
    if (userData !== null) {
      setUserCurrrentRole(userData.id)
      setHeaderData({
        username: userData.firstName + " " + userData.lastName,
        role: userData.role.name
      });
      userService.getUserAccount().then(response => {
        if (response.data.success) {
          setUserAccount(response.data.data)
          if (isOnBoarding) {
            localStorage.setItem(ACCOUNT_NUMBER, response.data.data.length)
          }
        }
      });
    } else {
      authService.getUserData().then(response => {
        if (response.data.success) {
          if (response.data.data !== null) {
            localStorage.setItem(CURRENT_USER, JSON.stringify(response.data.data));
            localStorage.setItem("sessionStart", Date.now().toString());
            // set data value
            setUserCurrrentRole(response.data.data.id)
            setHeaderData({
              username: response.data.data.firstName + " " + response.data.data.lastName,
              role: response.data.data.role.name
            });

            userService.getUserAccount().then(response => {
              if (response.data.success) {
                setUserAccount(response.data.data)
                if (isOnBoarding) {
                  localStorage.setItem(ACCOUNT_NUMBER, response.data.data.length)
                }
              }
            });
            // end set data value
          } else {
            localStorage.removeItem(CURRENT_USER);
            localStorage.removeItem("sessionStart");
            localStorage.removeItem("lastActivityAt");
            navigate("/", { replace: true });
          }
        } else {
          localStorage.removeItem(CURRENT_USER);
          localStorage.removeItem("sessionStart");
          localStorage.removeItem("lastActivityAt");
          navigate("/", { replace: true });
        }
      }).catch(err => {
        localStorage.removeItem(CURRENT_USER);
        localStorage.removeItem("sessionStart");
        localStorage.removeItem("lastActivityAt");
        navigate("/", { replace: true });
      });
    }
  }, []);

  const handleLogout = () => {
    dispatch(authActions.logout());
    localStorage.removeItem(CURRENT_USER);
    localStorage.removeItem("sessionStart");
    localStorage.removeItem("lastActivityAt");
    localStorage.removeItem(CURRENT_LANG);
    navigate('/', { replace: true });
  }

  const changeCulture = (x) => {
    setLoading(true);
    isFrench(x);
    const lan = x ? 'en' : 'fr'
    localStorage.setItem(CURRENT_LANG, lan);
    i18n.changeLanguage(lan);
    const currentLocation = window.location.href;
    window.location.href = currentLocation;
  }

  const handleChangeUserCurrrentRole = (event) => {
    setUserCurrrentRole(event.target.value);
    setLoading(true);
    authService.changeRole(event.target.value).then(response => {
      if (response.data.success) {
        localStorage.setItem(CURRENT_USER, JSON.stringify(response.data.data));
        localStorage.setItem("sessionStart", Date.now().toString());
        setUserData(response.data.data);
        if (response.data.data.role.id > 2) {
          window.location.href = "/page/management";
        } else {
          window.location.href = "/page/accueil";
        }
      } else {
        console.log("=> HERE <=")
        setLoading(false);
        setDisplayAlertError(true);
        setTimeout(() => {
          setDisplayAlertError(false);
        }, parseInt(REACT_APP_NOTIFICATION_DURATION) * 1000);
      }
    }).catch(err => {
      console.log("=> " + err.response.data.message)
      if (err.response.data.message == "NO_ACCESS") {
        window.location.href = "/page/accueil";
      } else if (err.response.data.message == "ACCESS_DENIED") {
        window.location.href = "/";
      }
      setLoading(false);
      setDisplayAlertError(true);
      setTimeout(() => {
        setDisplayAlertError(false);
      }, parseInt(REACT_APP_NOTIFICATION_DURATION) * 1000);
    });
  };

  const displayFileDoc = (fileName = "") => {
    setLoading(true);
    fileService.getFile(fileName)
      .then(response => {
        if (response.data.success) {
          var sampleArr = base64ToArrayBuffer(response.data.data);
          var blob = new Blob([sampleArr], { type: "application/pdf" });
          var link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          link.target = '_blank';
          link.click();
        } else {
        }
      })
      .catch(err => {
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleMemoCandidat = () => {
    const filePath = '/static/docs/Memo_Candidat_' + langTmp + '.pdf';
    window.open(filePath, '_blank');
  };

  const renderLangs = () => {
    return (
      <Grid item xs={1} >
        <h4 style={{ marginRight: -70, marginBottom: 10 }}>
          <a id="fr"
            onClick={() => changeCulture(false)}
            style={{
              paddingLeft: 0, paddingRight: 0,
              textDecoration: 'none',
              color: '#2d2927',
              cursor: 'pointer'
            }}>
            <span style={{
              marginLeft: '0.25rem',
              boxSizing: 'border-box',
              fontWeight: culture ? 'normal' : 900,
              margin: 4
            }}>FR</span></a>
          |
          <a id="en"
            onClick={() => changeCulture(true)}
            style={{
              paddingLeft: 0, paddingRight: 0,
              textDecoration: 'none',
              fontWeight: 'normal',
              color: '#2d2927',
              cursor: 'pointer'
            }}><span style={{
              marginLeft: '0.25rem',
              boxSizing: 'border-box',
              fontWeight: culture ? 900 : 'normal',
              margin: 4
            }}>EN</span></a>
        </h4>
      </Grid>
    );
  }

  return (
    <>
      <DialogChoiceLangSf
        open={openDialogChoiceLangSf}
        handleClose={() => {
          setOpenDialogChoiceLangSf(false)
          window.location.reload();
        }}
      />
      {loading && (
        <><SuspenseLoader /></>
      )}
      <HeaderWrapper display="flex" alignItems="center">
        <Grid
          container
          direction="row"
          alignItems="center"
          style={{ textAlign: 'center' }}
        >
          <Grid item xs={2} component={Link} to="/page/accueil" style={{ textAlign: 'right' }} >
            <img
              alt="Ligne vert"
              src="/static/images/logo/Trace 41.svg"
              style={{ height: 40 }}
            />
            <img
              alt="Ligne vert"
              src="/static/images/logo/Groupe 1.svg"
              style={{ height: 34 }}
            />
          </Grid>
          <Grid item xs={2} style={{ paddingLeft: 10 }}>
            <p style={{
              textAlign: 'left',
              margin: 0,
              color: '#2d2927',
              fontSize: 12,
              marginTop: 21
            }}><Trans>question</Trans></p>
            <p style={{
              textAlign: 'left',
              fontSize: 12,
              marginTop: -4
            }}>
              <Link
                to='#'
                onClick={(e) => {
                  window.location.href = "mailto:support-myskills@groupeastek.fr";
                  e.preventDefault();
                }}
              >
                support-myskills@groupeastek.fr
              </Link>
            </p>
          </Grid>
          <Grid item xs={3}>
            <Grid container direction="column" width={450}>
              <Grid item xs={12}>
                <h1 style={titleStyle}>MY SKILLS <Trans>{titleData}</Trans></h1>
              </Grid>
              <Grid item xs={12}>
                <Grid container direction="row" marginTop={-1} alignItems="center" justifyContent={'center'}>
                  {headerData.role !== 'Candidate' && (
                    <>
                      <Grid item>
                        <span onClick={() => displayFileDoc("Guide_DC_" + langTmp + ".pdf")} style={{ textDecoration: 'underline', cursor: 'pointer' }}>
                          <Trans>SFGuide</Trans>
                        </span>
                      </Grid>
                      <Grid item>
                        <span onClick={() => displayFileDoc("Notice_DC_" + langTmp + ".pdf")} style={{ marginLeft: 30, textDecoration: 'underline', cursor: 'pointer' }}>
                          <Trans>SFNotice</Trans>
                        </span>
                      </Grid>
                      <Grid item>
                        <span onClick={() => displayFileDoc("Guide_EEP_" + langTmp + ".pdf")} style={{ marginLeft: 30, textDecoration: 'underline', cursor: 'pointer' }}>
                          <Trans>EEPGuide</Trans>
                        </span>
                      </Grid>
                    </>
                  )}
                  {headerData.role === 'Candidate' && (
                    <>
                      <Grid item>
                        <span onClick={handleMemoCandidat} style={{ textDecoration: 'underline', cursor: 'pointer' }}>
                          <Trans>Memo</Trans>
                        </span>
                      </Grid>
                      <Grid item>
                        <span onClick={() => displayFileDoc("Guide_DC_" + langTmp + ".pdf")} style={{ marginLeft: 30, textDecoration: 'underline', cursor: 'pointer' }}>
                          <Trans>SFGuide</Trans>
                        </span>
                      </Grid>
                      <Grid item>
                        <span onClick={() => displayFileDoc("Notice_DC_" + langTmp + ".pdf")} style={{ marginLeft: 30, textDecoration: 'underline', cursor: 'pointer' }}>
                          <Trans>SFNotice</Trans>
                        </span>
                      </Grid>
                    </>
                  )}
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          {renderLangs()}
          <Grid item xs={2}>
            {userData !== null &&
              <>
                {userAccount.length >= 2 &&
                  <FormControl fullWidth>
                    <Select
                      inputProps={{ 'aria-label': 'Without label' }}
                      value={userCurrrentRole}
                      onChange={handleChangeUserCurrrentRole}
                      style={{
                        width: '120%',
                        color: "#000",
                        paddingLeft: 15,
                        height: 40,
                        marginLeft: 32,
                        fontWeight: 700,
                        marginTop: 6
                      }}
                    >
                      {userAccount.map((option) => (
                        option.isActive &&
                        <MenuItem key={option.id} value={option.id} style={{ whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden', fontWeight: 700, color: "#000" }} >
                          {isOnBoarding == true ? (option.firstName + " " + option.lastName + " (" + t('menu.managerAstek') + option.managerName + ")") : (option.firstName + " " + option.lastName + " (" + t(option.role.name) + ")")}
                        </MenuItem>
                      )
                      )}
                    </Select>
                  </FormControl>
                }
                {userAccount.length < 2 &&
                  <h4
                    title={usernameTitle}
                    style={{
                      width: '120%',
                      color: "#000",
                      paddingLeft: 15,
                      height: 40,
                      marginLeft: 32,
                      fontWeight: 700,
                      marginTop: 44,
                      whiteSpace: 'nowrap',
                      textOverflow: 'ellipsis',
                      overflow: 'hidden'
                    }}
                  >
                    {username}
                  </h4>
                }
              </>
            }
          </Grid>
          {
            <Grid item xs={1} >
              {props.isFicheDc && (
                <Tooltip title={t('dc.SFLanguage.settings')} placement="bottom-start">
                  <Button style={{
                    width: 20,
                    height: 39,
                    marginTop: 5,
                    marginRight: -120
                  }} onClick={() => { setOpenDialogChoiceLangSf(true); }}>
                    <img alt="lan" src={"/static/images/flags/lang_" + currentIdLangUserDc + ".png"} style={{ width: 18, height: 12 }} />
                  </Button>
                </Tooltip>
              )}
            </Grid>
          }
          <Grid item xs={1}>
            <AzureAD provider={authProvider} reduxStore={store}>
              {({ logout, authenticationState }) => {
                const isAuthenticated = authenticationState === AuthenticationState.Authenticated;
                const isUnauthenticated = authenticationState === AuthenticationState.Unauthenticated;
                if (isAuthenticated) {
                  return (
                    <Fragment>
                      <Button variant="contained"
                        color="secondary"
                        title={t('logoutLabel')}
                        onClick={async () => {
                          try {
                            await logout();
                          } catch (error) {
                            console.error('Erreur pendant AzureAD logout:', error);
                          } finally {
                            handleLogout();
                          }
                        }}
                        style={{ marginLeft: 10, minWidth: 34, maxWidth: 34, minHeight: 34, maxHeight: 34, borderRadius: '50%' }}
                      >
                        <ExitToAppIcon style={{ fontSize: 28 }} />
                      </Button>
                    </Fragment>
                  );
                } else if (isUnauthenticated) {
                  return (
                    <Fragment>
                      <Button variant="contained"
                        color="secondary"
                        title={t('logoutLabel')}
                        onClick={handleLogout}
                        style={{ marginLeft: 10, minWidth: 34, maxWidth: 34, minHeight: 34, maxHeight: 34, borderRadius: '50%' }}
                      >
                        <ExitToAppIcon style={{ fontSize: 28 }} />
                      </Button>
                    </Fragment>
                  );
                }
              }}
            </AzureAD>
          </Grid>
        </Grid>
      </HeaderWrapper>
    </>
  );
}

export default Header;

